import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";

// Landing Page Components
import { Header } from "./components/landing/Header";
import { HeroSection } from "./components/landing/HeroSection";
import { AboutSection } from "./components/landing/AboutSection";
import { TeamSection } from "./components/landing/TeamSection";
import { ServicesSection } from "./components/landing/ServicesSection";
import { IndustriesSection } from "./components/landing/IndustriesSection";
import { EngagementModelsSection } from "./components/landing/EngagementModelsSection";
import { WhyUsSection } from "./components/landing/WhyUsSection";
import { CaseStudiesSection } from "./components/landing/CaseStudiesSection";
import { ContactSection } from "./components/landing/ContactSection";
import { Footer } from "./components/landing/Footer";

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <TeamSection />
        <ServicesSection />
        <IndustriesSection />
        <EngagementModelsSection />
        <WhyUsSection />
        <CaseStudiesSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
